import { Component, ReactNode } from 'react'

interface FilterSheetErrorBoundaryProps {
  children: ReactNode
  fallback: ReactNode
  resetKey: boolean
}

interface FilterSheetErrorBoundaryState {
  hasError: boolean
}

export class FilterSheetErrorBoundary extends Component<
  FilterSheetErrorBoundaryProps,
  FilterSheetErrorBoundaryState
> {
  state: FilterSheetErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidUpdate(prevProps: FilterSheetErrorBoundaryProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false })
    }
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children
  }
}
